import type { FundCommandData } from '@festina/unitlink-general-types/unitlink'

import { AddFundDividendCommand } from '../../actions/fund/AddFundDividendCommand'
import { AddFundMergeCommand } from '../../actions/fund/AddFundMergeCommand'
import { ChangeFundCommand } from '../../actions/fund/ChangeFundCommand'
import { NewFundCommand } from '../../actions/fund/NewFundCommand'
import type { CommandDataRecord } from '../types'

export const fundCommands: CommandDataRecord<FundCommandData['_type']> = {
  AddFundDividendCommandData: AddFundDividendCommand,
  ChangeFundCommandData: ChangeFundCommand,
  NewFundCommandData: NewFundCommand,
  AddFundMergeCommandData: AddFundMergeCommand,
}
